module.exports = __webpack_public_path__ + "static/media/ruler.119fc6d9.svg";